<template>
    <PostViewPage :data="data" />
</template>
<script>
import { getPostDetail } from '@/api';
import PostViewPage from '@/views/common/PostViewPage.vue';

export default {
    components: {
        PostViewPage,
    },
    data() {
        return {
            data: null,
        };
    },
    methods: {
        async getData() {
            const { data } = await getPostDetail('/notice/detail', this.$route.params.id);
            if (!data) {
                const targetRoute = this.$route.path.split('/').slice(0, -1).join('/');
                this.$router.push({
                    path: targetRoute,
                    query: {
                        ...this.$route.query,
                    },
                });
            } else {
                this.data = data;
            }
        },
    },
    async mounted() {
        this.getData();
    },
    watch: {
        async $route() {
            this.getData();
        },
    },
};
</script>
